import StyledContainer from "style/styledContainer"
import styled from "styled-components"

import { ScrollOutBoxWrap, DrawerWinOneTileWrap, DrawerWinTwoTileWrap, PaddingLeftRightWrap, ScrollBoxWrap } from "../Drawer/DrawerStyle"
import { useCallback, useEffect, useState } from "react"
import DrawerCom from "components/Drawer/DrawerCom"

import illustrationMoneyImg from 'assets/images/illustration-money.png'
import EvmDetailCom from "./details/EvmDetailCom"

interface Props {
    open: boolean
    closeChange?: (isOpen: boolean) => void
    onComplete?: (obj?: any) => void
}

const DrawerWalletManageCom = ({open, closeChange = (isOpen) => {}, onComplete = (obj) => {}}: Props) => {

    /**
     * 资源初始化
     */
    const fnInit = useCallback(() => {
        if(open) {
            // 初始化资源

        } else {
            // 清理资源

        }
    }, [open])

    useEffect(() => {
        fnInit()
    }, [fnInit])

    /**
     * 关闭回调
     */
    const [closeRandom, setCloseRandom] = useState(0)
    const fnClosed = (closed: boolean) => {
        closeChange(closed)
        setCloseRandom(0)
    }
    const fnCloseWin = useCallback(() => {
        setCloseRandom(closeRandom + 1)
    }, [closeRandom])

    /**
     * 完成回调
     */
    const fnConfirm = () => {
        onComplete();
    }

    return open ? <DrawerCom isOpen={open} closeRandom={closeRandom} onClose={fnClosed}>
        <DrawerContentWrap>
            <PaddingLeftRightWrap>
                <DrawerWinOneTileWrap>Wallets management</DrawerWinOneTileWrap>
                <DrawerWinTwoTileWrap $mb="40px">Manage your connected wallet</DrawerWinTwoTileWrap>
            </PaddingLeftRightWrap>
            
            <ScrollOutBoxWrap $height="calc(100% - 100px) !important;">
                <ScrollBoxWrap>
                    <EvmDetailCom disconnectChange={fnCloseWin}></EvmDetailCom>
                    
                    <StyledContainer $height="50px"></StyledContainer>
                    <PlaceholderImg src={illustrationMoneyImg}></PlaceholderImg>
                    <StyledContainer $mt="23px" $fontSize="14px" $lineHeight="1.2" $fontWeight5 $textAlign="center">
                        If you want to connect another wallet, <br/>you first need to disconnect the existing wallet.
                    </StyledContainer>
                </ScrollBoxWrap>
            </ScrollOutBoxWrap>
        </DrawerContentWrap>
    </DrawerCom> : <></>
}


const DrawerContentWrap = styled(StyledContainer)`
    height: 100%;
`
const PlaceholderImg = styled.img`
    height: 124px;
    display: block;
    margin: 0 auto;
`

export default DrawerWalletManageCom